import { Customer } from './customerType';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class CustomerApi {

    static async create(customer: Customer) {
        try {
            const response = await fetch(`${API_BASE_URL}/customers`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ customer: customer }),
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();
            //console.log('==== //response.status === ', response.status)
            //console.log('=====responseBody======', responseBody.error)

            if (response.status === 201) {
                return responseBody
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(`${responseBody.error} status ${response.status}`);
                }

            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create customer: ${error.message}`);
            } else {
                throw new Error('Failed to create customer: An unknown error occurred.');
            }
        }
    }



    static async trackMessageLogs(customerId: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/customers/${customerId}/message_logs`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });
            //console.log('==== //response.status === ', response.status)
            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const customers: Customer[] = responseBody.data.map((item: any) => {
                    return {
                        customer_id: item.attributes.customer_id,
                        first_name: item.attributes.first_name,
                        last_name: item.attributes.last_name,
                        customer_company_name: item.attributes.customer_company_name,
                        address_1: item.attributes.address_1,
                        address_2: item.attributes.address_2,
                        city: item.attributes.city,
                        state: item.attributes.state,
                        zip: item.attributes.zip,
                        email: item.attributes.email,
                        phone: item.attributes.phone,
                        latitude: item.attributes.latitude,
                        longitude: item.attributes.longitude,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return customers;
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(`${responseBody.error} status ${response.status}`);
                }
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get customer: ${error.message}`);
            } else {
                throw new Error('Failed to get customer: An unknown error occurred.');
            }
        }
    }


    static async get() {
        try {
            const response = await fetch(`${API_BASE_URL}/customers/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });
            //console.log('==== //response.status === ', response.status)
            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const customers: Customer[] = responseBody.data.map((item: any) => {
                    return {
                        customer_id: item.attributes.customer_id,
                        first_name: item.attributes.first_name,
                        last_name: item.attributes.last_name,
                        customer_company_name: item.attributes.customer_company_name,
                        address_1: item.attributes.address_1,
                        address_2: item.attributes.address_2,
                        city: item.attributes.city,
                        state: item.attributes.state,
                        zip: item.attributes.zip,
                        email: item.attributes.email,
                        phone: item.attributes.phone,
                        latitude: item.attributes.latitude,
                        longitude: item.attributes.longitude,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return customers;
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(`${responseBody.error} status ${response.status}`);
                }
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get customer: ${error.message}`);
            } else {
                throw new Error('Failed to get customer: An unknown error occurred.');
            }
        }
    }



    static async update(customer_id: string, customer: Customer) {
        try {
            const response = await fetch(`${API_BASE_URL}/customers/${customer_id}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ customer: customer }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update customer: ${error.message}`);
            } else {
                throw new Error('Failed to update customer: An unknown error occurred.');
            }
        }
    }

    static async delete(customer_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/customers/${customer_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete customer: ${error.message}`);
            } else {
                throw new Error('Failed to delete customer: An unknown error occurred.');
            }
        }
    }

}

export default CustomerApi;